<template>
  <div :class="[isLogin]">
    <div class="gtranslate_wrapper" />
  </div>
</template>

<script>
export default {
  name: 'GTranslate',
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isLogin() {
      if (this.$route.name === 'login' || this.$route.name === 'esqueceu-senha') {
        if (!this.isMobile) {
          return 'gt-login gt-login-desktop';
        }
        return 'gt-login';
      }
      return '';
    },
  },
  mounted() {
    this.gTranslateInit();
  },
  methods: {
    gTranslateInit() {
      const scriptGTranslate = document.createElement('script');
      const url = 'https://cdn.gtranslate.net/widgets/latest/float.js';
      scriptGTranslate.src = url;
      scriptGTranslate.defer = true;

      document.head.appendChild(scriptGTranslate);

      this.gTranslateScript();
    },

    gTranslateScript() {
      window.gtranslateSettings = {
        default_language: 'pt',
        native_language_names: true,
        detect_browser_language: true,
        languages: ['pt', 'en', 'es', 'it', 'fr', 'nl', 'ja', 'id', 'pl', 'de', 'tr', 'ru', 'hi'],
        wrapper_selector: '.gtranslate_wrapper',
        switcher_horizontal_position: 'right',
        switcher_vertical_position: 'top',
        float_switcher_open_direction: 'bottom',
        alt_flags: {
          en: 'usa',
          pt: 'brazil',
        },
      };
    },
  },
};
</script>

<style lang="scss">
#gt_float_wrapper {
  top: 7px !important;
  right: 1% !important;
  z-index: 99 !important;

  @media (max-width: 1430px) {
      right: 20% !important;
  }

  @media (max-width: 959px) {
    right: 7% !important;
  }

  @media (max-width: 480px) {
    right: 11% !important;
  }
}

.gt_float_switcher {
  font-size: 14px !important;
  background-color: transparent !important;

  img {
    width: 24px !important;
  }

  .gt-selected {
    background-color: transparent !important;

    .gt-current-lang {
      padding: 5px 10px !important;
      color: #FFFFFF !important;
    }
  }
}

.gt_options {
  background-color: #FFFFFF !important;
}

.gt_float_switcher-arrow {
  background-image: none !important;
  display: none !important;
}

.gt-login {
  #gt_float_wrapper {
    right: 1% !important;
    position: absolute !important;
  }
}
.gt-login-desktop .gt_float_switcher .gt-selected .gt-current-lang {
  color: var(--v-primary-base) !important;
}
</style>
